import { ISeoMetaData } from '.'

export const accountSettingsSeoMetaData: ISeoMetaData[] = [
  {
    path: '/account-settings',
    seo: {
      en: {
        title: 'My account settings | Medicare',
        description: ''
      },
      es: {
        title: 'Configuración de mi cuenta | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/account-settings/get-my-medicare-card',
    seo: {
      en: {
        title: 'Get my Medicare card | Medicare',
        description: ''
      },
      es: {
        title: 'Conseguir mi tarjeta médica | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  ...seoMetaData,
  component: 'Account Settings'
}))
